import React, { memo } from "react";
import "./card.css";

const Card = memo(
  ({
    apiName,
    imageUrl,
    backgroundColor,
    apiNameStyles,
    borderColor,
    content,
  }) => {
    return (
      <div
        className="card-container-footer"
        style={{
          background: backgroundColor,
          border: `1px solid ${borderColor}`,
        }}
      >
        <div>
          <p className="card-headings-footer" style={apiNameStyles}>
            {apiName}
          </p>
          <p className="card-desc">
            {content
              ? content.split(/\s+/).slice(0, 4).join(" ") +
                (content.split(/\s+/).length > 4 ? " ....." : "")
              : ""}
          </p>
        </div>
        <div
          className="card-image-section-footer"
          // style={{ borderColor: borderColor }}
        >
          <img src={imageUrl} alt="" loading="lazy" decoding="async" />
        </div>
      </div>
    );
  }
);

export default Card;
